import styled from '@emotion/styled';
import { Paper } from '@mui/material';

export const TimerContainer = styled(Paper)`
  position: fixed;
  top: 90px;
  right: 20px;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 1000;

  &:hover {
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
    transition: all 0.3s ease;
  }
`;

interface TimeTextProps {
  isWarning: boolean;
}

export const TimeText = styled.div<TimeTextProps>`
  font-size: 1.2rem;
  font-weight: 500;
  color: ${props => (props.isWarning ? '#ff4444' : '#333333')};
`;
